<template>
  <div>
    <select v-model.number="selectedId">
      <option value="">-- 전시 선택 --</option>
      <option
        v-for="exhibition in exhibitionList"
        :key="exhibition.id"
        :value="exhibition.id"
      >
        {{ exhibition.title }} ({{ exhibition.uuid }})
      </option>
    </select>

    <a
      v-show="selectedId"
      :href="`https://article21.kr/exhibition/${selectedId}`"
      target="_blank"
      style="display: inline-block; margin-top: 4px;"
    >
      전시 보기
    </a>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps, defineEmits } from 'vue';
import { apiClient } from '@/services/auth-header';

const exhibitionList = ref([]);

const props = defineProps({
  contentId: { type: [String, Number], default: '' },
});
const emit = defineEmits(['update:contentId']);

const selectedId = computed({
  get: () => props.contentId,
  set: (value) => emit('update:contentId', value),
});

const fetchExhibitionList = async () => {
  try {
    const response = await apiClient.get('/contents/articles/exhibitions');
    exhibitionList.value = response.data;
  } catch (error) {
    console.error('전시 목록 조회 실패:', error);
  }
};

onMounted(() => {
  fetchExhibitionList();
});
</script>

<style scoped>
select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
</style>
